import Magic_circle from './magic_circle'
export default Magic_circle